import store from '@/store';

export default (to, from, next) => {
    if (!!store.getters.token && to.path === '/login') {
        return next({ path: from.path });
    }

    return next();
};
